import React, { useState, useEffect } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import {
  onSnapshot,
  collection,
  getDocs,
  where,
  query,
} from "firebase/firestore";
import { db } from "../../FirebaseConfig";
import Lists from "./Lists";

const PostedShoppingLists = () => {
  // My Shopping list Data
  const [shoppingListData, setShoppingListData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { uid } = useParams();

  useEffect(() => {
    const fetchShoppingLists = async () => {
      setLoading(true);
      const postsRef = collection(db, "posts");
      let q;

      q = query(
        postsRef,
        where("userId", "==", uid),
        where("postType", "==", "shoppingList")
      );

      let unsubscribe;
      try {
        unsubscribe = onSnapshot(q, async (querySnapshot) => {
          const shoppingListData = await Promise.all(
            querySnapshot.docs.map(async (document) => {
              const shoppingList = document.data();
              const dateCreated =
                shoppingList.dateCreated?.seconds ||
                new Date().getTime() / 1000;
              const lastUpdated =
                shoppingList.lastUpdated?.seconds ||
                new Date().getTime() / 1000;

              // Fetch up to 3 media items from the media subcollection
              const mediaRef = collection(postsRef, document.id, "media");
              const mediaQuery = query(mediaRef);
              const mediaDocs = await getDocs(mediaQuery);
              const products = mediaDocs.docs.map((mediaDoc) => ({
                id: mediaDoc.id,
                ...mediaDoc.data(),
              }));

              return {
                id: document.id,
                name: shoppingList.listName,
                dateCreated,
                lastUpdated,
                products,
                listId: shoppingList.listId,
                sizes: shoppingList.sizes,
                visibility: shoppingList.visibility,
                ownerId: uid,
                ...shoppingList,
              };
            })
          );

          const shoppingListDataArray = await Promise.all(shoppingListData);
          shoppingListDataArray.sort((a, b) =>
            b.lastUpdated && a.lastUpdated
              ? b.lastUpdated - a.lastUpdated || a.dateCreated - b.dateCreated
              : a.dateCreated - b.dateCreated
          );
          setShoppingListData(shoppingListDataArray);
        });
        setLoading(false);
      } catch (error) {
        console.error("Error setting up snapshot listener:", error);
      } finally {
        setLoading(false);
      }

      return unsubscribe;
    };

    window.scrollTo(0, 0);
    fetchShoppingLists();
  }, [uid]);
  return (
    <>
      {/* Nav Strip under Header */}

      <Routes>
        <Route
          path="/"
          element={
            <Lists shoppingListData={shoppingListData} loading={loading} />
          }
        />
      </Routes>
    </>
  );
};

export default PostedShoppingLists;
